export default __webpack_public_path__ + "static/media/quartzo.61b4ff46.png";